import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';

import { Observable } from 'rxjs';

import { QuickScanDetail } from 'modules/shared/models/quick-scan.models';

import { environment } from 'environment/environment';

export interface INewQuickScan {
  name: string;
  recordType: string;
  scanEngines: string;
  domains: Array<any>;
  extraData: string;
}

export interface IQuickScansReqParams {
  limit?: number;
  offset?: number;
  search?: string;
  sort?: string;
}

@Injectable()
export class QuickScansService {

  readonly baseUrl: string = environment.API_BASE + '/quickscan';

  constructor(private httpClient: HttpClient) { }

  /**
   * Create new quick scan request
   * @method createQuickScan
   */
  createQuickScan(newScan: INewQuickScan): Observable<QuickScanDetail> {
    return this.httpClient.post<QuickScanDetail>(`${this.baseUrl}/search/`, newScan);
  }

  /**
   * Get info about quick scan by id
   * @method getQuickScan
   */
  getQuickScan(id: number): Observable<QuickScanDetail> {
    return this.httpClient.get<QuickScanDetail>(`${this.baseUrl}/records/${id}/`);
  }

  /**
   * Get info about quick scans
   * @method getQuickScans
   */
  getQuickScans(quickScansReqBody?: IQuickScansReqParams): Observable<Array<QuickScanDetail>> {
    let params: HttpParams = new HttpParams();

    if (quickScansReqBody) {
      const reqBodyEntries: Array<[string, any]> = Object.entries(quickScansReqBody);

      reqBodyEntries.forEach(([key, value]: [string, any]) => {
        if (value !== undefined) {
          params = params.append(key, value);
        }
      });
    }

    return this.httpClient.get<Array<QuickScanDetail>>(`${this.baseUrl}/search/`, { params: params });
  }

  /**
   * Batch upload file
   * @method batchUpload
   */
  batchUpload(data: FormData): Observable<Array<QuickScanDetail>> {
    return this.httpClient.post<Array<QuickScanDetail>>(`${this.baseUrl}/records/bulk_create/`, data);
  }
}
